import React, { useRef, useCallback, useState } from 'react';

export const EXCEL_IMPORT_ACCEPT =
  '.xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export const useFileSelect = (accept?: string) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const openFileDialog = useCallback(() => {
    inputRef.current?.click();
  }, []);

  const onFileChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    setSelectedFile(file);
    e.target.value = '';
  }, []);

  const FileInput = (
    <input type="file" accept={accept} ref={inputRef} onChange={onFileChange} style={{ display: 'none' }} />
  );

  return {
    selectedFile,
    openFileDialog,
    FileInput,
    clearSelectedFile: () => setSelectedFile(null),
  };
};
